import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'
import moment from "moment";

const state = {
  categoryName: 'ロケーション',

  // model
  locationModel: {},
  serviceModel: [],

  // model : サービス運用者の場合のみ
  serviceInfoModel: {},
}

const getters = {
  get: state => state,

  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.locationModel[key]
      switch (key) {
        case 'createdAt':
        case 'updatedAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
        default:
          return value
      }
      /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  },
  // ステータス
  getStatus: state => () => {
    try {
      if (!state.locationModel.createdAt)
        return Constants.BlankValue
      else if (!state.locationModel.isExpiryEnabled)
        return '有効'
      else if (state.locationModel.expirationDate)
        return moment().isAfter(moment(state.locationModel.expirationDate), 'day') ? '無効' : '有効'
    } catch (e) {
      return ''
    }
  },
  isDeviceSpLinkCodeIssued: state => () => {
    try {
      return !!state.locationModel.deviceSpLinkCode
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel({commit}, {serviceParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = []
      const methods = []
      const parameters = []

      // システム管理者の場合
      if (isAdmin) {
        // サービス一覧を取得
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push({})
        // サービス運用者の場合
      } else {
        // ユーザーが属するサービス情報を取得
        types.push('service')
        methods.push('v1ServiceDetailGet')
        parameters.push(serviceParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            if (isAdmin) {
              commit('setServiceModel', res[0].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)
            } else {
              commit('setServiceInfoModel', res[0].data.serviceBasicInfo)
              console.log('serviceInfoModel', state.serviceInfoModel)
            }
            resolve()
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * スマホデバイス連携詳細取得
   */
  loadLocationList({commit}, {locationParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['location'],
        ['v1LocationSpLinkageDetail'],
        [locationParams])
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            commit('setLocationModel', res[0].data)
            console.log('locationModel', state.locationModel)
            resolve()
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  resetState({commit}) {
    commit('resetState')
  }
}

const mutations = {
  // model
  setServiceModel(state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },
  setServiceInfoModel(state, data) {
    Vue.set(state, 'serviceInfoModel', data)
  },
  setLocationModel(state, data) {
    Vue.set(state, 'locationModel', data)
  },
  resetState(state) {
    Vue.set(state, 'serviceModel', [])
    Vue.set(state, 'serviceInfoModel', {})
    Vue.set(state, 'locationModel', null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
